import { buildHref } from "@softmax/web-addresses";
import { FeatureLink } from "@softmax/web-features/navigation";

import { NavigationReady } from "@softmax/web-features/navigation/markers";

export function PlayIndexPage() {
  return (
    <main
      id="main"
      className="flex min-h-screen flex-col items-center justify-center px-[32px] py-[64px] text-center"
    >
      <NavigationReady stage="content" path={buildHref({ name: "play" })} />
      <h1 className="font-plex-mono text-[28px] font-semibold leading-[34px] text-[#161616]">
        Play
      </h1>
      <p className="mt-[12px] text-[14px] leading-[20px] text-[rgba(22,22,22,0.70)]">
        You&apos;re not in a league yet.
      </p>
      <FeatureLink
        href={buildHref({ name: "browse" })}
        className="mt-[16px] text-[14px] font-medium text-[#161616]"
      >
        Browse leagues ›
      </FeatureLink>
    </main>
  );
}
